/**
* file uploadのコンストラクタ
* @constructor
* @param {selector} - el jqueryセレクタ
*/
module.exports = Upload = function(el){
  this.element = $(el);
  this.element.find('input[type="file"]').on('change', function(){
    var val = $(this)[0].files[0].name;
    $('.js-upload-value').text(val);
  });
};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/upload.js
// module id = 11
// module chunks = 0